import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
const achievements = ['Romper el loop mental del vapeo', 'Protocolos para frenar la ansiedad en 7 minutos', 'Guía para no engordar en el proceso', 'Plan de 30 días con objetivos diarios claros'];
export function WhatYouGet() {
  return <section className="py-6 md:py-24 px-4 bg-gray-50 border-t border-gray-200" data-id="element-203">
      <div className="max-w-3xl mx-auto" data-id="element-204">
        <FadeIn data-id="element-205">
          <div className="text-center mb-6 md:mb-12" data-id="element-206">
            <h2 className="font-display font-black text-3xl md:text-5xl text-gray-900" data-id="element-207">
              LO QUE VAS A LOGRAR
            </h2>
          </div>
        </FadeIn>

        <StaggerContainer className="space-y-3 md:space-y-4" data-id="element-208">
          {achievements.map((item, idx) => <StaggerItem key={idx} className="bg-white border border-gray-200 rounded-xl p-4 md:p-6 flex items-center space-x-4 shadow-sm" data-id="element-209">
              <CheckCircle2 className="text-celeste shrink-0" size={28} data-id="element-210" />
              <span className="text-lg md:text-2xl text-gray-800 font-medium" data-id="element-211">
                {item}
              </span>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}